module.exports = __webpack_public_path__ + "static/media/kangan.85b18d19.jpg";